module.exports = __webpack_public_path__ + "img/marketo.6d497c7c.svg";